<template>
  <Teleport to="body">
    <Transition name="modal">
      <div v-if="modelValue"
        class="admin-modal-overlay fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
        @click.self="handleClose">
        <div
          class="admin-modal-content bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto relative"
          :class="contentClass" data-modal-content>
          <button v-if="showCloseButton" type="button" @click.stop="handleClose"
            class="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors z-10" aria-label="Close">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <div class="bg-white p-6 md:p-8">
            <slot />
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
defineProps({
  modelValue: {
    type: Boolean,
    required: true
  },
  showCloseButton: {
    type: Boolean,
    default: true
  },
  contentClass: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:modelValue', 'close'])

const handleClose = () => {
  emit('update:modelValue', false)
  emit('close')
}
</script>

<style scoped>
.admin-modal-overlay {
  backdrop-filter: blur(2px);
}

.admin-modal-content {
  background-color: #FFFFFF !important;
}

.admin-modal-content>div {
  background-color: #FFFFFF !important;
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.2s ease;
}

.modal-enter-active .admin-modal-content,
.modal-leave-active .admin-modal-content {
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .admin-modal-content,
.modal-leave-to .admin-modal-content {
  transform: scale(0.95);
  opacity: 0;
}
</style>
